import client from './client';
import { unwrapData } from './response';

export const getDashboardData = async () => {
  const response = await client.get('/dashboard/executive');
  return unwrapData(response, {});
};
